import { TrackingEvent } from '@jimdo/frontend-tracking';
import React from 'react';
import { Allocation, JimdoApp } from './types';

export const ExperimentContext = React.createContext({
  allocations: [] as Allocation[],
  track: (event: Omit<TrackingEvent, 'category'>) => {},
  jimdoApp: JimdoApp.UNDEFINED,
  debugMode: false,
});
